import { render, staticRenderFns } from "./detail-table.vue?vue&type=template&id=beb3db8a&scoped=true&"
import script from "./detail-table.vue?vue&type=script&lang=js&"
export * from "./detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb3db8a",
  null
  
)

export default component.exports